// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q1LA","colBig":"styles_colBig__3mTUk","colSmall":"styles_colSmall__2Y8r-","shopifyNameWrapper":"styles_shopifyNameWrapper__1BTLr"};